import { render, staticRenderFns } from "./home-dashboard.vue?vue&type=template&id=60ef5ce7&scoped=true"
import script from "./home-dashboard.vue?vue&type=script&lang=js"
export * from "./home-dashboard.vue?vue&type=script&lang=js"
import style0 from "./home-dashboard.vue?vue&type=style&index=0&id=60ef5ce7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef5ce7",
  null
  
)

export default component.exports